import { z } from 'zod'

// GLOBAL ACADEMIC TERMS

export const GlobalAcademicTermSchema = z.object({
  id: z.number(),
  name: z.string(),
  code: z.string(),
})

export const GlobalAcademicTermsArraySchema = z.array(GlobalAcademicTermSchema)
export type GlobalAcademicTerm = z.infer<typeof GlobalAcademicTermSchema>
export type GlobalAcademicTermsArray = z.infer<
  typeof GlobalAcademicTermsArraySchema
>

// PROGRAM ACADEMIC TERMS

export const AcademicTermSchema = z.object({
  id: z.number(),
  academic_term_type_id: z.number(),
  term_number: z.number(),
  name: z.string(),
})

export const ProgramTermStatusSchema = z.union([
  z.literal('Planned'),
  z.literal('Active'),
  z.literal('Completed'),
  z.literal('Inactive'),
])
export type ProgramTermStatus = z.infer<typeof ProgramTermStatusSchema>

export const ProgramTermSchema = z.object({
  id: z.number(),
  program_id: z.number(),
  academic_term_id: z.number(),
  name: z.string(),
  status: z.number(),
  school_year: z.string(),
  awarding_period_start_date: z.string().nullable(),
  awarding_period_end_date: z.string().nullable(),
  created_at: z.string(),
  updated_at: z.string(),
  academic_term_name: z.string(),
  status_name: ProgramTermStatusSchema,
  academic_term: AcademicTermSchema,
})

export const ProgramTermsArraySchema = z.array(ProgramTermSchema)

// Type inference
export type AcademicTerm = z.infer<typeof AcademicTermSchema>
export type ProgramTerm = z.infer<typeof ProgramTermSchema>
export type ProgramTermsArray = z.infer<typeof ProgramTermsArraySchema>
